interface OpusLogoProps {
  className?: string;
  animated?: boolean;
}

export function OpusLogo({ className = 'h-8 w-8', animated = true }: OpusLogoProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={animated ? { animation: 'opus-spin 3s linear infinite' } : undefined}
    >
      <defs>
        <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6EE7B7" />
          <stop offset="50%" stopColor="#34D399" />
          <stop offset="100%" stopColor="#10B981" />
        </linearGradient>
        <radialGradient id="ballGradient">
          <stop offset="0%" stopColor="#6EE7B7" />
          <stop offset="100%" stopColor="#34D399" />
        </radialGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Main ring with gap */}
      <path
        d="M 43 15 A 35 35 0 1 1 15 43"
        stroke="url(#ringGradient)"
        strokeWidth="12"
        strokeLinecap="round"
        fill="none"
        filter="url(#glow)"
      />

      {/* Ball in gap */}
      <circle cx="27" cy="27" r="6" fill="url(#ballGradient)" filter="url(#glow)" />

      {/* Highlight on ball */}
      <circle cx="25" cy="25" r="1.8" fill="white" opacity="0.9" />
    </svg>
  );
}
